<div class="h-screen w-screen app text-white">
  <div id="bg-overlay"></div>
  <router-outlet></router-outlet>
  @if (message) {
  <div
    class="fixed flex flex-col top-0 right-0 left-0 bottom-0 backdrop-blur-sm bg-black/30"
  >
    <div
      class="bg-white text-black/80 max-w-md mx-auto my-auto p-5 rounded-xl flex flex-col items-center"
    >
      <ng-icon name="heroCog" class="animate-spin" size="32"></ng-icon>
      <div class="text-center mt-5">
        {{ message }}
      </div>
    </div>
  </div>
  }
</div>
